exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".perf-tool .left-hand{position:absolute;top:0;bottom:0;left:0;width:200px;border-right:1px solid #ccc;background-color:#f3f3f3;min-height:400px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/left-hand.css
 ** module id = 210
 ** module chunks = 0
 **/